<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      enable-resize-watcher
      fixed
      app
    >
      <side-drawer></side-drawer>
    </v-navigation-drawer>
    <v-toolbar
      app
      color="white"
    >
      <v-btn icon @click="goBack()">
        <v-icon>keyboard_arrow_left</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-toolbar-title>Shipments for Order {{ salesOrderNo }}</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-content>
      <v-list two-line fill-height>
        <div v-for="(item, index) in items" :key="item.deliveryOrderNo">
          <v-list-tile
            avatar
            ripple
          >
            <v-list-tile-content>
              <v-list-tile-title>{{ (item.customCourierName.length > 0 ? item.customCourierName : item.courierName + ' - ' +  item.serviceName) }}</v-list-tile-title>
              <v-list-tile-sub-title>{{ item.createdDateTime | formatDate('DD MMM YYYY HH:mm', profile.gmtTimezone) }}</v-list-tile-sub-title>
              <v-list-tile-sub-title class="text--primary">Tracking no: {{ item.trackingNo }}</v-list-tile-sub-title>
            </v-list-tile-content>

            <v-list-tile-action>
              <v-list-tile-action-text>
                <v-btn outline small color="primary" class="mr-3" v-if="item.trackingNo" :href="item.fullTrackingUrl" target="_blank">Track</v-btn>
                <v-btn icon color="primary" :to="'/shipment/' + item.deliveryOrderNo">
                  <v-icon>keyboard_arrow_right</v-icon>
                </v-btn>
              </v-list-tile-action-text>
            </v-list-tile-action>

          </v-list-tile>
          <v-divider
            v-if="index + 1 < items.length"
            :key="index"
          ></v-divider>
        </div>
        <template
          v-if="items.length <= 0"
        >
          <v-flex
            xs12
            justify-center
            align-center
            text-xs-center
          >
            <v-icon x-large color="primary">error_outline</v-icon>
            <div>
              No shipment yet
            </div>
          </v-flex>
        </template>

      </v-list>
      <!--<v-fab-transition>
        <v-btn
          color=primary
          dark
          fab
          fixed
          bottom
          right
        >
          <v-icon>add</v-icon>
        </v-btn>
      </v-fab-transition>-->
      <v-dialog
        v-model="loading"
        hide-overlay
        persistent
        width="220"
      >
        <loading></loading>
      </v-dialog>
    </v-content>
  </div>
</template>

<style scoped>
  .media {
    height: 100%;
    margin: 0;
  }

  table.v-table tbody td:first-child {
    padding: 15px 15px;
  }

  .item-name {
    padding: 5px !important;
  }

  .item-thumb {
    width: 60px;
    height: auto;
  }
</style>

<script>
import SideDrawer from '@/components/SideDrawer.vue'
import axios from 'axios'
import router from '../router'
import Loading from '@/components/Loading.vue'

export default {
  props: [
    'salesOrderNo'
  ],
  components: {
    SideDrawer,
    Loading
  },
  data () {
    return {
      profile: this.$store.getters.getProfile,
      drawer: false,
      loading: false,
      items: []
    }
  },
  mounted () {
    this.openDrawerForDesktop()
    this.listSalesOrderShipments()
  },
  methods: {
    listSalesOrderShipments: function () {
      this.loading = true
      axios.get(process.env.VUE_APP_API_ROOT + '/v1/sales/' + this.salesOrderNo)
        .then(resp => {
          this.loading = false
          if (resp.data.status === 'success') {
            this.items = resp.data.data.deliveryOrders
          } else {
            console.log('unable to load shipments: ' + resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + this.$route.fullPath)
            }
            this.loading = false
          }
        })
    }
  }

}
</script>
